<template>
  <div class=""></div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {
    let url = this.$route.query?.url || ''
    if (url) {
      location.href = url
    } else {
      this.$toast('跳转url不存在')
    }
    this.$betterwe.onAppCloseRoute()
  },
  methods: {}
}
</script>
<style lang="scss" scoped></style>
